module.exports = __webpack_public_path__ + "img/ic_head_hight_0.6437471d.png";